import { ProSidebar, Menu, SubMenu, MenuItem, SidebarHeader, SidebarContent } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { logo1Controller } from "../../../../dynamicController";

const Sidebar = ({ toggled, setToggled, themeLogo, distributor }) => {
	return (
		<ProSidebar breakPoint="xl" toggled={toggled} onToggle={val => setToggled(val)} id="react-pro-sidebar">
			<SidebarHeader id="react-pro-sidebar-header">
				<Link to="/distributor/dashboard">
					<img src={logo1Controller(themeLogo)} alt="logo" className="img-fluid" />
				</Link>
			</SidebarHeader>

			<SidebarContent id="react-pro-sidebar-content">
				<Menu id="react-pro-sidebar-menu" iconShape="circle" popperArrow={true}>
					<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-home"></i>}>
						Dashboard <Link to="/distributor/dashboard" />
					</MenuItem>

					{
						distributor.store_performance || distributor.user_performance || distributor.voucher_redemption || distributor.token_report || distributor.sms_report ? (
							<SubMenu title="Report" icon={<i className="fas fa-file-invoice-dollar"></i>}>
								{
									distributor.store_performance ? (
										<MenuItem>
											Store Performance <Link to="/distributor/outlet/performance" />
										</MenuItem>
									) : <></>
								}
								{
									distributor.user_performance ? (
										<MenuItem>
											User Performance <Link to="/distributor/user/performance" />
										</MenuItem>
									) : <></>
								}
								{
									distributor.voucher_redemption ? (
										<MenuItem>
											Voucher Redemption <Link to="/distributor/voucher/redemption" />
										</MenuItem>
									) : <></>
								}
								{
									distributor.token_report && distributor.token ? (
										<MenuItem>
											Token Report <Link to="/distributor/token/report" />
										</MenuItem>
									) : <></>
								}
								{
									process.env.REACT_APP_STORETYPE !== "cuci" && distributor.sms_report ? (
										<MenuItem>
											SMS Report <Link to="/distributor/sms/report" />
										</MenuItem>
									) : <></>
								}
							</SubMenu>
						) : <></>
					}

					{
						distributor.user_detail ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-user-cog"></i>}>
								User Details <Link to="/distributor/user/details" />
							</MenuItem>
						) : <></>
					}

					{
						distributor.user_reward ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-gift"></i>}>
								User Rewards <Link to="/distributor/giveaway" />
							</MenuItem>
						) : <></>
					}

					{
						distributor.voucher_setting ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-cogs"></i>}>
								Voucher Setting <Link to="/distributor/voucher/setting" />
							</MenuItem>
						) : <></>
					}

					{
						distributor.token_setting ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-coins"></i>}>
								Token Setting <Link to="/distributor/token/setting" />
							</MenuItem>
						) : <></>
					}

					{
						distributor.referral_setting ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-user-friends"></i>}>
								Referral Setting <Link to="/distributor/referral" />
							</MenuItem>
						) : <></>
					}

					{
						distributor.discount_code ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-percent"></i>}>
								Discount Code <Link to="/distributor/discountCode" />
							</MenuItem>
						) : <></>
					}

					{process.env.REACT_APP_STORETYPE !== "cuci" && distributor.customize_color ? (
						<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-palette"></i>}>
							Customize Color <Link to="/distributor/setting/customize" />
						</MenuItem>
					) : (
						<></>
					)}

					{
						distributor.faq_setting ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-question-circle"></i>}>
								FAQs <Link to="/distributor/faq" />
							</MenuItem>
						) : <></>
					}

					{
						distributor.news_setting ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-newspaper"></i>}>
								News <Link to="/distributor/news" />
							</MenuItem>
						) : <></>
					}

					{
						distributor.user_migration ? (
							<MenuItem className="react-pro-sidebar-menu-item" icon={<i className="fas fa-user"></i>}>
								User Migration <Link to="/distributor/migration" />
							</MenuItem>
						) : <></>
					}

				</Menu>
			</SidebarContent>
		</ProSidebar>
	);
};

const mapStateToProps = state => {
	return {
		themeLogo: state.theme.logo,
		distributor: state.distributor.distributor
	};
};

export default connect(mapStateToProps, null)(Sidebar);
